module.exports = __webpack_public_path__ + "static/media/bg_07.1f373e1a.png";